import React from 'react';
import { List } from '@mui/material';
import WaveLayersEditor from '../../components/WaveLayersEditor/WaveLayersEditor';
import VisualizerShapeEditor from '../../components/VisualizerShapeEditor';
import VisualizerMotionEditor from '../../components/VisualizerMotionEditor';
import VisualizerEffectsEditor from '../../components/VisualizerEffectsEditor';

const SettingsPanelVisualizerSubTabContent = ({ tabValue }) => {
    return (
        <>
            {tabValue === 0 &&
                <List
                    dense
                    disablePadding
                >
                    <WaveLayersEditor advanced />
                </List>
            }
            {tabValue === 1 &&
                <List
                    dense
                    disablePadding
                >
                    <VisualizerShapeEditor />
                </List>
            }
            {tabValue === 2 &&
                <List
                    dense
                    disablePadding
                >
                    <VisualizerMotionEditor />
                </List>
            }
            {tabValue === 3 &&
                <List
                    dense
                    disablePadding
                >
                    <VisualizerEffectsEditor />
                </List>
            }
        </>
    );
}

export default SettingsPanelVisualizerSubTabContent;